import { gql } from '@apollo/client';

const GET_ABOUT_US = gql`
  query ComponentAboutUsServiceAboutUs {
    header {
      headerButtons {
        id
        label
        variant
      }
      navigationLinks {
        id
        title
        url
      }
      headerLogo {
        id
        label
        url
        image {
          url
        }
      }
    }

    aboutUs {
      blocks {
        ... on ComponentAboutUsServiceAboutUs {
          id
          title
          subTitle
          backgroundImage {
            name
            url
          }
          cardList {
            id
            title
            serviceCard {
              id
              title
              description
              button {
                id
                label
              }
            }
          }
          button {
            id
            label
          }
          ServiceCard {
            id
            title
            description
            button {
              id
              label
            }
          }
        }
        ... on ComponentAboutUsHeroSection {
          id
          title
          subTitle
          scrollingImage {
            name
            url
          }
        }
        ... on ComponentAboutUsAimSection {
          id
          backgroundImage {
            name
            url
          }
          cardList {
            id
            title
            description
            cardMedia {
              url
              name
            }
            heading
          }
        }
        ... on ComponentScheduleSectionScheduleSection {
          id
          backgroundImage {
            url
            name
          }
          title
          buttonsList {
            id
            label
            variant
          }
          description
        }
        ... on ComponentSharedVideoLink {
          id
          url
        }
        ... on ComponentPartnerCareServicesPartnerCareServices {
          id
          title
          subTitle
          backgroundImage {
            name
            url
          }
          button {
            id
            label
          }
          cardList {
            id
            title
            subTitle
            icon {
              url
              name
            }
          }
        }
        ... on ComponentAboutBenefitsAboutBenefits {
          id
          title
          subTitle
          button {
            id
            label
          }
          cardList {
            id
            heading
            title
            description
            cardMedia {
              url
              name
            }
            button {
              id
              label
            }
          }
        }
        ... on ComponentCeoSectionCeoSection {
          id
          heading
          subTitle
          backgroundImage {
            name
            url
          }
          ceoList {
            id
            name
            about
            image {
              url
              name
            }
          }
        }
        ... on ComponentContactUsLocationSliderList {
          id
          locationSliderList {
            id
            location
            backgroundImage {
              url
              name
            }
          }
        }
      }
    }

    footer {
      navigationBox {
        links {
          id
          label
          url
          isExternal
        }
        title
      }
      contactInfoBox {
        infoDetailsList {
          id
          label
          icon {
            url
            name
          }
        }
        title
      }
      socialLinkBox {
        iconLinkList {
          icon {
            url
          }
          isExternal
          url
        }
      }
      downloadLinks {
        id
        url
        linkImage {
          width
          name
          url
        }
      }
      footerBottom {
        privacyLinks {
          id
          label
          url
          isExternal
        }
        copyRights
      }
      privacyPolicyContent
      termsConditionContent
    }
  }
`;
export default GET_ABOUT_US;
